import NewCompany from './NewCompany';

export default NewCompany;

